import * as React from 'react';
export const retrieveraiSvg = React.forwardRef(function retrieveraiSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F3EEE5',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm7.2 5.199-.2.19v7.577c0 6.457.016 7.68.12 8.276.224 1.239.696 2.192 1.553 3.081.592.628 1.265 1.096 2.177 1.525 1.593.739 3.754 1.152 6.083 1.152 3.242 0 5.635-.842 6.98-2.462.752-.898 1.144-2.129 1.08-3.384-.048-.81-.168-1.096-.52-1.23-.272-.104-.712.04-.84.27-.056.095-.12.516-.145.929-.032.587-.096.857-.256 1.215-.408.858-1.336 1.62-2.36 1.922-.641.19-1.73.278-2.418.198-.905-.103-1.553-.285-2.33-.659-.536-.254-.816-.46-1.328-.969-.496-.484-.72-.786-.936-1.239-.537-1.104-.577-1.39-.577-4.24.008-2.383.016-2.582.184-3.17.096-.35.32-.929.497-1.294.44-.898 1.304-1.771 2.2-2.232a9.222 9.222 0 0 1 1.241-.5c.505-.143.865-.175 2.161-.207.857-.016 1.641-.048 1.745-.071.337-.072.4-.406.377-2.018-.032-2.637-.024-2.525-.2-2.7-.145-.143-.265-.159-1.553-.159-1.57 0-2.418.12-3.53.484-1.153.382-2.185 1.017-3.154 1.923-.216.206-.424.373-.464.373-.032 0-.064-.556-.072-1.231 0-1.072-.024-1.247-.152-1.39-.136-.151-.24-.159-2.658-.159H7.392l-.192.199Z',
      fill: '#171717',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.5 23a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
      fill: '#F37EB9',
    }),
  );
});
retrieveraiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var retrieverai = {
  category: 'brand',
  colorable: false,
  name: 'retrieverai',
  svg: retrieveraiSvg,
};
